module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper pt-header65"
  }, [_c('header', {
    staticClass: "gheader -white gheader-fix"
  }, [_c('div', {
    staticClass: "gheader__link-back"
  }, [_c('a', {
    on: {
      "click": _vm.goTop
    }
  }, [_vm._v("戻る")])])]), (_vm.searchCallbackFlag) ? _c('div', {
    staticClass: "container bg02 document-renewal"
  }, [_vm._m(0), (_vm.items.length === 0) ? _c('div', {
    staticClass: "document-renewal__empty"
  }, [_c('p', [_vm._v("現在、更新が必要な書類はありません。")])]) : _vm._e(), _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      staticClass: "document-renewal__item"
    }, [_c('h2', [_vm._v(_vm._s(item.documentTypeName))]), _c('p', {
      staticClass: "document-renewal__deadline"
    }, [_vm._v("期限日：" + _vm._s(item.deadlineDate || '未登録'))]), (item.renewal) ? _c('div', {
      staticClass: "mt10"
    }, [_c('span', {
      staticClass: "document-renewal__status",
      class: '-' + item.renewal['status']
    }, [_vm._v(_vm._s(item.renewal['status-i18n']))]), _c('span', {
      staticClass: "fz12 ml5"
    }, [_vm._v("（" + _vm._s(item.renewal['created-at-format']) + " 提出）")]), (item.renewal['status'] === 'rejected') ? _c('p', {
      staticClass: "document-renewal__comment"
    }, [_vm._v("差戻し理由：" + _vm._s(item.renewal['review-comment']))]) : _vm._e(), (item.renewal['status'] === 'submitted') ? _c('p', {
      staticClass: "document-renewal__note"
    }, [_vm._v("店舗管理者・事務員の確認をお待ちください。")]) : _vm._e(), (item.renewal['status'] === 'confirmed') ? _c('p', {
      staticClass: "document-renewal__note"
    }, [_vm._v("確認が完了し、期限日を更新しました。"), _c('br'), _vm._v("新しい期限日：" + _vm._s(item.deadlineDate))]) : _vm._e(), (item.renewal['status'] === 'rejected') ? _c('p', {
      staticClass: "document-renewal__note"
    }, [_vm._v("お手数ですが、再度ご提出ください。")]) : _vm._e()]) : _vm._e(), (item.file) ? _c('div', {
      staticClass: "document-renewal__preview"
    }, [(item.previewSrc) ? _c('img', {
      attrs: {
        "src": item.previewSrc
      }
    }) : _vm._e(), (!item.previewSrc) ? _c('p', [_vm._v("PDF：" + _vm._s(item.file.name))]) : _vm._e(), (item.previewSrc) ? _c('p', {
      staticClass: "fz11"
    }, [_vm._v(_vm._s(item.file.name))]) : _vm._e()]) : _vm._e(), _c('div', {
      staticClass: "document-renewal__buttons"
    }, [_c('button', {
      staticClass: "btn02 -camera",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.openCamera(item)
        }
      }
    }, [_c('span', [_vm._v("撮影する")])]), _c('button', {
      staticClass: "btn02",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.openFile(item)
        }
      }
    }, [_c('span', [_vm._v("ファイルを選ぶ")])])]), _c('input', {
      ref: 'cameraInput_' + item.documentType,
      refInFor: true,
      attrs: {
        "type": "file",
        "accept": "image/*",
        "capture": "environment"
      },
      on: {
        "change": function($event) {
          _vm.onFileChange(index, $event)
        }
      }
    }), _c('input', {
      ref: 'fileInput_' + item.documentType,
      refInFor: true,
      attrs: {
        "type": "file",
        "accept": ".jpg,.jpeg,.png,.pdf,image/jpeg,image/png,application/pdf"
      },
      on: {
        "change": function($event) {
          _vm.onFileChange(index, $event)
        }
      }
    }), _c('p', {
      staticClass: "document-renewal__note"
    }, [_vm._v("※「撮影する」でカメラが起動しない機種では、「ファイルを選ぶ」からカメラを選んで撮影してください。")]), (item.error) ? _c('p', {
      staticClass: "document-renewal__error"
    }, [_vm._v(_vm._s(item.error))]) : _vm._e(), (item.file) ? _c('div', {
      staticClass: "document-renewal__submit"
    }, [_c('button', {
      staticClass: "btn01",
      class: item.submitting ? '-unavailable' : '',
      attrs: {
        "type": "button",
        "disabled": item.submitting
      },
      on: {
        "click": function($event) {
          _vm.submit(index)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.submitting ? '提出中...' : '提出する'))])])]) : _vm._e()])
  })], 2) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "document-renewal__intro"
  }, [_c('h1', [_vm._v("書類の更新をお願いします")]), _c('p', {
    staticClass: "fz13 mt10"
  }, [_vm._v("期限が近づいている書類を、カメラで撮影するかファイルを選んで提出してください。")]), _c('p', {
    staticClass: "fz13 mt5"
  }, [_vm._v("期限日が「未登録」の書類は、入社手続きで提出がまだのものです。お持ちの場合はここから提出してください。")]), _c('p', {
    staticClass: "fz11 mt5"
  }, [_vm._v("（jpg / png / pdf、1ファイル10MBまで）")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-450634e4!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/document-renewal-list.pug
// module id = 1406
// module chunks = 1